import request, { formatUrl } from './request';

export const fetchDataFilters = (campaignId, presentationType) => {
  return request({
    method: 'GET',
    url: formatUrl('/negociant/filters', {
      campaign_id: campaignId,
      presentation_type: presentationType
    }),
    protectedRoute: true,
    newApi: true
  });
};

export const fetchDataSubmissions = ({ campaignId }) => {
  return request({
    method: 'GET',
    url: `/negociant/campaign/${campaignId}/submissions-stats-by-wine`,
    protectedRoute: true,
    newApi: true
  });
};

export const fetchDataSynthesisKpi = ({ campaignId, saleTypeId, wineId }) => {
  return request({
    method: 'GET',
    url: `/negociant/campaign/${campaignId}/stats/kpis?sale_type_id=${saleTypeId}&wine_id=${wineId}`,
    protectedRoute: true,
    newApi: true
  });
};

export const fetchDataSynthesisSalesByCountry = ({
  campaignId,
  saleTypeId,
  wineId
}) => {
  return request({
    method: 'GET',
    url: `/negociant/campaign/${campaignId}/stats/sales-by-country?sale_type_id=${saleTypeId}&wine_id=${wineId}`,
    protectedRoute: true,
    newApi: true
  });
};

export const fetchDataSynthesisSalesByWine = ({ campaignId, saleTypeId }) => {
  return request({
    method: 'GET',
    url: `/negociant/campaign/${campaignId}/stats/sales-by-wine?sale_type_id=${saleTypeId}`,
    protectedRoute: true,
    newApi: true
  });
};

export const fetchDataTopNegociants = ({ campaignId, saleTypeId, wineId }) => {
  return request({
    method: 'GET',
    url: `/negociant/campaign/${campaignId}/negociants?sale_type_id=${saleTypeId}&wine_id=${wineId}`,
    protectedRoute: true,
    newApi: true
  });
};

export const fetchDataTopCustomers = ({ campaignId, saleTypeId, wineId }) => {
  return request({
    method: 'GET',
    url: `/negociant/campaign/${campaignId}/customers?sale_type_id=${saleTypeId}&wine_id=${wineId}`,
    protectedRoute: true,
    newApi: true
  });
};

export const fetchDataPresentationKpis = ({
  campaignId,
  negociantId,
  wineId
}) => {
  return request({
    method: 'GET',
    url: `/negociant/campaign/${campaignId}/negociant/${negociantId}?wine_id=${wineId}`,
    protectedRoute: true,
    newApi: true
  });
};

export const fetchDataRaw = ({
  campaignId,
  saleTypeId,
  wineId,
  negociantId
}) => {
  return request({
    method: 'GET',
    url: `/negociant/campaign/${campaignId}/raw_data?sale_type_id=${saleTypeId}&wine_id=${wineId}&negociant_id=${negociantId}`,
    protectedRoute: true,
    newApi: true
  });
};
